import { type FC } from 'react'
import classNames from 'classnames'

import { ChevronRight } from '@foxino/icons-react'

import FoxinoSmallLogo from '@app/assets/images/foxinoSmallLogo.svg?react'
import resolveTailwindClasses from '@app/utils/resolveTailwindClasses'

import { useSideNavigationHover } from '../../hooks/useSideNavigationHover'
import { sideNavigationStore } from '../../store/sideNavigationStore'

type Props = {
  className?: string
}

export const FoxinoHeaderLogo: FC<Props> = ({ className }) => {
  const { isHidden, onHoverStart, onHoverEnd } = useSideNavigationHover()

  const onArrowClick = () => {
    sideNavigationStore.setIsHidden(!isHidden)
  }

  return (
    <div
      onMouseEnter={onHoverStart}
      onMouseLeave={onHoverEnd}
      className={resolveTailwindClasses(
        'relative flex size-10 items-center justify-center rounded-[10px] bg-primary-900',
        className
      )}
    >
      <FoxinoSmallLogo className="size-6" />
      <div className="absolute -right-2 flex cursor-pointer items-center justify-center rounded-full border-[0.5px] border-primary-500 bg-primary-600 p-0.5 hover:bg-primary-700">
        <ChevronRight className={classNames('size-3', !isHidden && 'rotate-180')} onClick={onArrowClick} />
      </div>
    </div>
  )
}
